<div class="ui-move"><ui-svg-icon name="move" :size="24"></ui-svg-icon></div>